import 'regenerator-runtime/runtime';
import { NOT_FOUND, redirect } from 'redux-first-router';
import { fetchData } from './utils/async';

// Customer specific data is loaded in frontend.
// Generic data for all clients is SSR
const clientUpdate = (dispatch, getState) => {
	if (getState().environment.navigation.open) dispatch({ type: 'OPEN_MENU' });

	if (typeof window !== 'undefined') {
		if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
		window.dataLayer.push({
			event: 'PageView',
			values: {
				path: getState().location.pathname,
			},
		});
	}
};

const clientInit = async (dispatch, getState) => {
	clientUpdate(dispatch, getState);

	dispatch({ type: 'SITE_UPDATED' });

	return getState();
};

export default {
	CLIENT_INIT: {
		thunk: async (dispatch, getState) => clientInit(dispatch, getState).catch((err) => console.log('DEBUG: error initiating client site data', err)),
	},
	STATIC: {
		path: '/static/:noop?',
	},
	START: {
		path: '/:language?',
		thunk: async (dispatch, getState, bag) => {
			const { languages = {} } = getState().environment.setup;

			// best guess that it's start page otherwise cached...
			const body = getState().environment.setup.previewCode ? { previewCode: getState().environment.setup.previewCode } : {};
			const startPage = !getState().pageData || !getState().pageData.start ? fetchData('', body) : getState().pageData.start;
			let { hash = '' } = bag.action.payload;
			let startPageData;
			clientUpdate(dispatch, getState);

			hash = typeof window !== 'undefined' && window.location.hash !== '' && window.location.hash !== '#' ? window.location.hash : hash;
			dispatch({ type: 'UPDATE_HASH', hash });

			try {
				startPageData = await startPage;
			} catch (err) {
				console.log('DEBUG: start page data not retrieved');
			}

			dispatch({ type: 'PAGE_DATA', data: startPageData, page: 'start' });
			dispatch({ type: 'PAGE_PATHS', pageType: 'start', paths: Object.keys(languages).reduce((acc, pathLanguage) => ({ ...acc, [pathLanguage]: '' }), {}) });
		},
	},
	CATEGORY_PRODUCT_PAGE: {
		path: '/:language?/:path+',
		thunk: async (dispatch, getState) => {
			const { location, environment } = getState();
			let language = location.payload.language;
			// Clean any encoded URI characters
			let path = decodeURIComponent(location.payload.path).replace(/^\/+/, '');
			let search = '';

			// Remove any hashes from path
			if (path.indexOf('#') !== -1) path = path.slice(0, path.indexOf('#'));
			// Remove any queries from path
			if (path.indexOf('?') !== -1) {
				search = path.slice(path.indexOf('?'));
				path = path.slice(0, path.indexOf('?'));
			} else if (location.search) {
				search = `?${location.search}`;
			}
			// "language" is probably not a language but a path.
			if (language.length > 2) {
				path = `${language}/${path}`;
				language = false;
			}

			// Get content for site.
			const body = environment.setup.previewCode ? { previewCode: environment.setup.previewCode } : {};
			const page = !getState().pageData || !getState().pageData[path] ? fetchData(path, body) : getState().pageData[path];
			clientUpdate(dispatch, getState);
			let pageData;

			try {
				pageData = await page;
			} catch (err) {
				console.log('DEBUG: failed page data not retrieved');
			}

			if (pageData.paths) {
				dispatch({ type: 'PAGE_PATHS', pageType: pageData.pageType, paths: pageData.paths });
				if (path !== pageData.paths[language] && pageData.paths[language]) {
					return dispatch(redirect({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pageData.paths[language], search, hash } }));
				}
			}

			if (pageData.content.is404) {
				dispatch({ type: 'PAGE_DATA', data: pageData, page: '404' });
				return dispatch({ type: NOT_FOUND });
			}

			return dispatch({ type: 'PAGE_DATA', data: pageData, page: path });
		},
	},
};
